import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChartEUR } from "../components/ComponentChartEUR";
import { ComponentChartUSD } from "../components/ComponentChartUSD";
import { SlideContext } from "../Context";
import { REPORT_ID } from '../constants';

export const slide16ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_ID === identification.reportId) {
    if (identification.componentId === "chart-usd") {
      input.component = <ComponentChartUSD context={componentContext as SlideContext}></ComponentChartUSD>;
    }
    if (identification.componentId === "chart-eur") {
      input.component = <ComponentChartEUR context={componentContext as SlideContext}></ComponentChartEUR>;
    }
  }
  return next(input);
};
